module.exports = __webpack_public_path__ + "img/baseball_keychain.583d3154.png";